module.exports = __webpack_public_path__ + "static/media/photo277.4f6d15bc.jpg";